import { ShieldCheck, Phone, Star, Award } from "lucide-react";

const ITEMS = [
  { icon: ShieldCheck, label: "Assicurazione totale inclusa" },
  { icon: Star, label: "Recensioni verificate 4.9 / 5" },
  { icon: Award, label: "18+ anni di esperienza in Sicilia" },
  { icon: Phone, label: "Preventivo in 60 minuti" },
];

export default function TrustStrip() {
  return (
    <section data-testid="trust-strip" className="relative bg-brand-ink text-white overflow-hidden">
      <div className="absolute inset-0 opacity-[0.07] grain" />
      <div className="max-w-7xl mx-auto px-5 lg:px-8 py-4 lg:py-5 flex flex-wrap items-center justify-center gap-x-6 lg:gap-x-10 gap-y-3">
        {ITEMS.map(({ icon: Icon, label }, i) => (
          <div key={i} className="flex items-center gap-2 text-[11px] lg:text-[13px] tracking-wide" data-testid={`trust-item-${i}`}>
            <Icon className="w-3.5 h-3.5 lg:w-4 lg:h-4 text-brand-muted" />
            <span className="font-medium">{label}</span>
          </div>
        ))}
      </div>
    </section>
  );
}
